/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { MouseEvent, ReactNode } from 'react';
import type { Id } from 'react-toastify';
import AlertToastMessage from './AlertToastMessage';
import { openRetainedToastDetails, type RetainedToastType } from './toastHistoryStore';

interface Props {
  content: ReactNode;
  id: Id;
  type: RetainedToastType;
}

export default function AlertToastContent({ content, id, type }: Readonly<Props>) {
  const viewDetails = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    openRetainedToastDetails(id);
  };

  return (
    <AlertToastMessage
      content={content}
      action={
        <button
          aria-label={`View full ${type} details`}
          className="alert-toast-details-link"
          onClick={viewDetails}
          type="button"
        >
          Details
        </button>
      }
    />
  );
}
